import styled from "styled-components";
import {theme} from "../../configuration";

const LabelHiddenInWideView = styled.span`
  display: none;
  font-size: 0.8em;
  
  @media (max-width: ${theme.pageWidthForSingleColumnHelpResults}) {
    display: inline;
  }
`;

export default LabelHiddenInWideView;
